import React, { useState } from "react";
import MideaViewer from "../../../midea_viewer/MideaViewer";
// css comes in create_hw_finle.css
import axios from "../../../axios";
import { iconData } from "../../../iconData";

function CrossQueryAttachment({
  attachment,
  setAttach,
  attachMent2,
  setAttachment2,
  indexToRemove,
}) {
  const [mideaviewer, setMideaviewer] = useState(false);
  const handleRemoveAttachment = async () => {
    try {
      let res = await axios.delete(`/file/delete`, {
        data: { file_path: attachment },
      });

      if (attachMent2 && attachMent2.length > 0) {
        const newArrayLimit = [...attachMent2];
        newArrayLimit.splice(indexToRemove, 1);
        setAttachment2(newArrayLimit);
      }
      res &&
        setAttach((prev) =>
          prev.filter((i) => {
            return i !== attachment;
          })
        );
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className="hw_defult_attach_box ml-3">
        <div className="d-flex align-items-center justify-content-between mt-2">
          <div
            className="d-flex align-items-center"
            onClick={() => setMideaviewer(!mideaviewer)}
          >
            <img
              style={{ width: "16px", height: "16px" }}
              className="mr-2 hw_defult_attach_type_icon"
              src={`${
                iconData?.find(
                  (i) =>
                    i.extension ===
                    attachment.substring(attachment.lastIndexOf(".") + 1)
                )?.icon
              }`}
              alt="icon"
            />

            <span className="hw_default_attach_name">
              {attachment?.replace(/^[^_]*_/, "")}
            </span>
          </div>

          <img
            style={{ marginLeft: "15px" }}
            onClick={handleRemoveAttachment}
            src="/images/attachment_cross_icon.png"
            alt="icon"
          />
        </div>
      </div>
      {mideaviewer && (
        <MideaViewer
          closeMideaviewer={setMideaviewer}
          attachment={attachment}
        />
      )}
    </>
  );
}

export default CrossQueryAttachment;
